import { createContext, useContext } from 'react';

/**
 * True inside a {@link SkeletonPulse}: the group breathes as one, so the grey
 * shapes inside it render static instead of each running its own animation
 * (out-of-phase bars read as flicker, and N animations cost N).
 */
export const SkeletonPulseContext = createContext(false);

export const useInsideSkeletonPulse = () => useContext(SkeletonPulseContext);
